import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LivePricingState } from "../../types";
import { axiosObj } from "../../../config/apiClients";

const initialState: LivePricingState = {
  isLoading: false,
  marketStatus: "",
  prices: [],
  XAG: {
    buyingMargin: 0,
    sellingMargin: 0,
    customBuyingPrice: 0,
    customSellingPrice: 0
  },
  XAU: {
    buyingMargin: 0,
    sellingMargin: 0,
    customBuyingPrice: 0,
    customSellingPrice: 0
  },
}

export const updateMargin = createAsyncThunk(
  "settings/update-margin",
  async (margins: any, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/settings/update-margin', margins);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to update margins' });
    }
  }
)

export const getMargin = createAsyncThunk(
  "/settings/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/settings/getAll');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Get Market Hours' });
    }
  }
)

export const updateCustomMarketPrice = createAsyncThunk(
  "/settings/update-market-custom-prices",
  async (customPrices: any, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/settings/update-market-custom-prices', customPrices);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Custom Market Prices' });
    }
  }
)

const livePricingSlice = createSlice({
  name: "livePricing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateMargin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateMargin.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateMargin.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getMargin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMargin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.marketStatus = action.payload.payload.marketStatus;
        state.XAG = action.payload?.payload?.settings[0]?.XAGUSD;
        state.XAU = action.payload?.payload?.settings[0]?.XAUUSD;
      })
      .addCase(getMargin.rejected, (state) => {
        state.isLoading = false;
      });
  },
})

export default livePricingSlice.reducer;